import React from 'react';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {ItemCell, ItemAccord, ItemContainer} from '../../components/modules/grids/Item';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import imgab from '../../components/images/abruzzowines/intestato/vigneto.png';
import './abruzzovini.scss';
import '../../css/fonts/fonts.scss';

function AbruzzoVini() {
    const {themes, error, loading} = useThemes();
    // Componente 1 - Carica articles Abruzzo
    const {articles} = useArticles('abruzzowines');
    const abruzzowines_Theme = themes[0];
    // Componente 2 - Carica Theme Abruzzo
    const abruzzoThemeArray = themes[3] ? (themes[3].accordion || []) : [];
    const aquila_Theme = themes[4]? (themes[4].accordion || []) : []; // Prende direttamente l'elemento all'indice Aquila
    const chieti_Theme = themes[5]? (themes[5].accordion || []) : []; // Prende direttamente l'elemento all'indice chieti
    const pescara_Theme = themes[6]? (themes[6].accordion || []) : []; // Prende direttamente l'elemento all'indice pescara 
    const teramo_Theme = themes[7]? (themes[7].accordion || []) : []; // Prende direttamente l'elemento all'indice teramo
    const abruzzo_Theme = abruzzoThemeArray[0] || null; // Prende il primo oggetto

    const abruzzo = [aquila_Theme, chieti_Theme, pescara_Theme, teramo_Theme]
        .filter(accordionArray => Array.isArray(accordionArray) && accordionArray.length > 0)
        .map(accordionArray => accordionArray[0]);  // Prende solo il primo oggetto  

    const province = abruzzo.map(link => ({
        titolo: link.sotto_titolo,
        id_accord: link?.id_accord || 0,
        collegamento: "/provincedellabruzzo"
    })); 

    const abwines_Articles = articles || [];
    const links = articles.map(article => ({id: article._id, titolo: article.articolo_titolo, collegamento: article.collegamento}));
    
    // ✅ 4. SOLO ORA condizioni e early return
    if (loading) return <div>Loading themes and articles...</div>;
    if (error) return <div>Error loading themes and articles: {error}</div>;
    
    return (
        <section className='grid-tema'>
            <div className="tema__photo"
                style={{
                    backgroundImage: `linear-gradient( to right bottom, rgba(39, 38, 38, 0.2), rgba(29, 26, 26, 0.5)),
                    url(${imgab})`, 
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    filter: 'brightness(90%)'
                }} >
            <ItemContainer tema={abruzzowines_Theme} exTema={abruzzo_Theme} links_Up={links} links_Down={province}/> 
            </div>
            <MenuMobile temi={themes}/>
            <div className="layout__grids">
                <ItemCell item={abwines_Articles}/>
            </div>
            <div className="tema__title">
                {abruzzo_Theme && <h1 className="title__top">{abruzzo_Theme.name}</h1>}
            </div>
            <div className="layout__grids">
                <ItemAccord item={abruzzo}/>
            </div>
        </section>
    )  
}
export default AbruzzoVini;
